<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive==='false' || isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" class="active"  routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()"[ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li (click)="goToforms()"[ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div *ngIf="showPolicySearch" class="p-3">
            <label class="bold fs-18 txt-black">Policy Search</label>
            <div class="col-sm-10 col-md-10 col-lg-12 col-xl-12 col-12">
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Policy Number</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Policy Number" [(ngModel)]="policyNumber" (keyup.enter)="onClickPolicySearch()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Credit Card Number</label>
                        <div class="row">
                          <div class="col-sm-3 col-md-4 col-lg-4 col-xl-4 col-3">
                              <input type="text" class="form-control forminput" maxlength="2" minlength="2" placeholder="First 2 digits" [(ngModel)]="creditCardNumber1" (keyup.enter)="onClickPolicySearch()">
                          </div>
                          <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-3 text-center">
                              <label class="regular fs-14 txt-black">*****</label>
                          </div>
                          <div class="col-sm-3 col-md-4 col-lg-4 col-xl-4 col-3">
                              <input type="text" class="form-control forminput" maxlength="4" minlength="4" placeholder="Last 4 digits" [(ngModel)]="creditCardNumber2" (keyup.enter)="onClickPolicySearch()">
                          </div>
                      </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Application Date</label>
                        <div class="row">
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [(ngModel)]="applicationStartDate">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time> -->
                            <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 policy-search-datepicker">
                                <mat-form-field  appearance="fill">
                                    <input matInput [matDatepicker]="datepicker1" placeholder="ddmmmyyyy" [(ngModel)]="applicationStartDate" (dateChange)="callApplicationStartDateFunction()" (click)="datepicker1.open()" (keyup.enter)="onClickPolicySearch()">
                                    <mat-datepicker #datepicker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <label class="bold fs-16 txt-black col-sm-5 col-md-1 col-lg-1 col-xl-1 col-1 text-center">&nbsp;-&nbsp;</label>
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [(ngModel)]="applicationEndDate">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time> -->
                            <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 policy-search-datepicker">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="datepicker2" placeholder="ddmmmyyyy" [(ngModel)]="applicationEndDate" (dateChange)="callApplicationEndDateFunction()" (click)="datepicker2.open()" (keyup.enter)="onClickPolicySearch()">
                                    <mat-datepicker #datepicker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Departure Date</label>
                      <div class="row">
                          <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [(ngModel)]="departureStartDate">
                          <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time> -->
                          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 policy-search-datepicker">
                            <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="datepicker3" placeholder="ddmmmyyyy" [(ngModel)]="departureStartDate" (dateChange)="callDepartureStartDateFunction()" (click)="datepicker3.open()" (keyup.enter)="onClickPolicySearch()">
                                <mat-datepicker #datepicker3></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <label class="bold fs-16 txt-black col-sm-5 col-md-1 col-lg-1 col-xl-1 col-1 text-center">&nbsp;-&nbsp;</label>
                          <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" [(ngModel)]="departureEndDate">
                          <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time> -->
                          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 policy-search-datepicker">
                            <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="datepicker4" placeholder="ddmmmyyyy" [(ngModel)]="departureEndDate" (dateChange)="callDepartureEndDateFunction()" (click)="datepicker4.open()" (keyup.enter)="onClickPolicySearch()">
                                <mat-datepicker #datepicker4></mat-datepicker>
                            </mat-form-field>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">First Name</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" [(ngModel)]="firstName" (keyup.enter)="onClickPolicySearch()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Last Name</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" [(ngModel)]="lastName" (keyup.enter)="onClickPolicySearch()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Purchaser Name</label>
                      <div>
                          <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Purchaser Name" [(ngModel)]="purchaserName" (keyup.enter)="onClickPolicySearch()">
                      </div>
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Purchaser Phone Number</label>
                      <div>
                          <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Purchaser Phone Number" [(ngModel)]="purchaserPhoneNumber" (keyup.enter)="onClickPolicySearch()">
                      </div>
                  </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Email Address</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Purchaser Email ID" [(ngModel)]="purchaserEmailId" (keyup.enter)="onClickPolicySearch()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                        <label class="regular fs-14 txt-black">Date of Birth </label>
                        <!-- <input class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt33" [owlDateTime]="dt33" [(ngModel)]="dob">
                        <owl-date-time [pickerType]="'calendar'" #dt33></owl-date-time> -->
                        <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10 policy-search-datepicker">
                            <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="datepicker5" placeholder="ddmmmyyyy" [(ngModel)]="dob" (dateChange)="callDOBFunction()" (keyup.enter)="onClickPolicySearch()">
                                <mat-datepicker-toggle matSuffix [for]="datepicker5"></mat-datepicker-toggle>
                                <mat-datepicker #datepicker5></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black"> Agency Code</label>
                      <div>
                          <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Agency Code" [(ngModel)]="agencyCode">
                      </div>
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-12">
                      <label class="regular fs-14 txt-black">Agent ID</label>
                      <div>
                          <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Agent ID" [(ngModel)]="agentId">
                      </div>
                  </div> -->
                </div>
            </div>
        <div class="clear10"></div>
        <button type="button" class="fs-16 bold addbtn mr-3" (click)="onClickPolicySearch()">Search</button>
        <!-- <span class="fs-14 regular txt-red">(Click Search without any criteria to view the most recent policies issued)</span> -->
        <div class="clear10"></div>
        <div class="tableheadFix" *ngIf="showSearchedPolicy">
            <div class="whitebox1 row">
                <span class="fs-14 bold leads mt-1 ml-1">&nbsp;POLICIES&nbsp;({{policyTotal}})&nbsp;</span>
                <span class="fs-14 regular mt-1 ml-1">&nbsp;Showing&nbsp;&nbsp;</span>
                <select class="form-control selectinput displead mt-1">
                <option disabled hidden value="undefined">30</option>
                <option value="15">15</option>
                 <option value="30">30</option>
                 <option value="45">45</option>
                 <option value="60">60</option>
                 <option value="100">100</option>
            </select>
            <img (click)="refreshPage()" style="padding: 6px;height: 33px;" src="./assets/images/refresh.png" class="cp disin ml-1" data-toggle="tooltip" title="Refresh">
            </div>
            <div class="clear10"></div>
            <table id="LinkToLead" class="w100">
                <thead class="nowrap">
                    <tr>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>POLICY</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('p.policy_number')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('p.policy_number')"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>INSURED</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('pii.first_name')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('pii.first_name')"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>PLAN</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('pl.plan_name')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('pl.plan_name')"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>STATUS</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('ps.policy_status')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('ps.policy_status')"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>APP DATE</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('p.application_date')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('p.application_date')"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>TRAVEL DATES</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up" (click)="onPolicySortAsc('p.effective_date')"></i>
                                    <i class="fa fa-caret-down" (click)="onPolicySortDsc('p.effective_date')"></i>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr  *ngFor="let item of userPolicyDetails | paginate: { itemsPerPage: onSelectSizePage, currentPage: p, totalItems: policyTotal}; let i=index">
                        <td><span class="link cp" (click)="onClickPolicyNumber(item.id,item.policyNumber)">{{item.policyNumber}}</span></td>
                        <td>
                            <div class="col-lg-10 col-xl-10">
                                <div class="ml-2" style="word-wrap: break-word;">
                                      <!-- {{data.name}} -->
                                      <label *ngIf="item.name!=null && item.name!='null' ">
                                        <!-- {{item.name || " "}} -->
                                        <span [innerHTML]="item.name.replace(',', ',<br>')"></span>
                                    </label>
                                  </div>
                                </div>
                        </td>
                        <td><label *ngIf="item.planName!=null">{{item.planName ||" "}}</label></td>
                        <td><label *ngIf="item.status!=null">{{item.status ||" "}}</label></td>
                        <td>{{item.applicationDate | date:'dd MMM yyyy'}}</td>
                        <td>{{item.effectiveDate | date:'dd MMM yyyy'}} - {{item.expiryDate | date:'dd MMM yyyy'}}</td>
                    </tr>
                    <!-- <tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr><tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr><tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr><tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr><tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr><tr>
                        <td><span class="link cp">TAG1153</span></td>
                        <td>RateTester Guy</td>
                        <td>Visitors To Canada Premier Plan</td>
                        <td>ACTIVE</td>
                        <td>03/02/2022</td>
                        <td>03/02/2022 - 03/02/2022</td>
                    </tr> -->
                </tbody>
            </table>
            <pagination-controls (click)="pageChnageDone(p)" (pageChange)="p = $event" class="float-right"></pagination-controls>
        </div>
        </div>
        <div *ngIf="showPolicyDetails || showRefundPolicy">
            <div class="whitebox p-3">
                <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search</label>
                <label class="bold fs-20 red5 m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
                <label class="bold fs-18 txt-black m-0 cp" (click)="onClickPolicyNumber1()">{{policyNumber1}}</label>
                <label class="bold fs-20 red5 m-0" *ngIf="showRefundPolicy">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
                <label class="bold fs-18 red5 m-0" *ngIf="showRefundPolicy" (click)="onClickPolicyNumber1()">Refund Policy</label>
            </div>
            <div *ngIf="showPolicyDetails">
                <div class="p-3">
                    <button type="button" class="btns red5" (click)="onClickRefundPolicy()">Refund Policy</button>
                    <button type="button" class="btns txt-blue3" (click)="onClickChangePolicy()">Change Policy</button>
                    <button type="button" class="btns green" >Clone Policy</button>
                    <button type="button" class="btns txt-lightblack2" (click)="printPopup=!printPopup">Email</button>
                </div>
                <div class="border-bottom"></div>
                <div class="p-3">
                    <div class="whitebox1" *ngFor="let item of getPolicyData">
                        <label class="bold fs-16 red5 m-0">Policy Basics:</label>
                        <label class="bold fs-16 green m-0">&nbsp;&nbsp;Active</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agent</label>
                                <div class="bold fs-14 purple">Test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Departure</label>
                                <div class="bold fs-14 purple">Vancouver</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Destination</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Ref Num</label>
                                <div class="bold fs-14 purple">234567</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Beneficiary</label>
                                <div class="bold fs-14 purple">Belgium</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                                <div class="bold fs-14 purple">$0.00</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Premium</label>
                                <div class="bold fs-14 purple">$27.72 ($27.72 + $0.00 tax) 8.32c</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1" *ngFor="let item of getPolicyData">
                        <label class="bold fs-16 red5 m-0">Policy Dates</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Effective</label>
                                <div class="bold fs-14 purple">{{item.effectiveDate  | date:'dd MMM yyyy'}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Expiry</label>
                                <div class="bold fs-14 purple">{{item.expiryDate  | date:'dd MMM yyyy'}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">{{item.noOfDays}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Application</label>
                                <div class="bold fs-14 purple">{{item.applicationDate  | date:'dd MMM yyyy'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1" *ngFor="let item of getPolicyData">
                        <label class="bold fs-16 red5 m-0">Contact Information</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Name</label>
                                <div class="bold fs-14 purple">{{item.purchaserName}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Address</label>
                                <div class="bold fs-14 purple">{{item.purchaserAddress1}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Email</label>
                                <div class="bold fs-14 purple mr-2 breakAll">{{item.purchaserEmailAddress}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Phone1</label>
                                <div class="bold fs-14 purple">{{item.purchaserPhone1}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Phone2</label>
                                <div class="bold fs-14 purple">{{item.purchaserPhone2}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Language</label>
                                <div class="bold fs-14 purple">{{item.language}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1" *ngFor="let item of getPolicyData">
                        <label class="bold fs-16 red5 m-0">Plan:</label>
                        <label class="bold fs-16 red5 m-0">&nbsp;&nbsp;{{item.planName}}</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                                <div class="bold fs-14 purple">04/17/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Option</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Option</label>
                                <div class="bold fs-14 purple">Wait Periodc</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1" *ngFor="let data of transactionDetails">
                        <div *ngFor="let data1 of data.transactionPaymentDetails">
                        <label class="bold fs-16 red5 m-0">Payments</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Date</label>
                                <div class="bold fs-14 purple">{{data1.sslTxnTime | date:'dd MMM yyyy'}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Type</label>
                                <div class="bold fs-14 purple">{{data1.cardType}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                                <div class="bold fs-14 purple">${{data1.sslAmount}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                                <div class="bold fs-14 purple">$00</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Card Number</label>
                                <div class="bold fs-14 purple">{{data1.sslCardNumber}}</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">EXp</label>
                                <div class="bold fs-14 purple">{{data1.sslExpDate}}</div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Other Info</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Fulfillment</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showRefundPolicy" class="p-3">
                <label class="bold fs-16 txt-black">REFUND POLICY</label>
                <div class="clear5"></div>
                <div class="border-bottom"></div>
                <div class="clear10"></div>
                <label class="regular fs-16 txt-lightgrey">Please enter reason for refund</label>
                <div class="row">
                    <textarea rows=4 class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12" [(ngModel)]="refundPolicyReason" (input)="removeRefundError()"></textarea>
                </div>
                <p class="dateSubtxt1 red" *ngIf="showReasonError">Reason is required</p>
                <div class="clear10"></div>
                <button type="button" class="btn-upload" >Process Refund</button>
                <div class="clear10"></div>
                <div class="border-bottom"></div>
                <div class="clear10"></div>
                <label class="bold fs-16 txt-black">PAYMENTS TO BE REFUNDED</label>
                <div class="clear10"></div>
                <div class="tableheadFix">
                    <table id="RefundPolicy" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>DATE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>TYPE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>PAYMENT AMOUNT</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>ADMIN FEE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>CARD NUMBER</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>EXP (MMYY)</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr>
                                <td><span>03/22/2022</span></td>
                                <td>Cheque</td>
                                <td>$46</td>
                                <td>$0.00</td>
                                <td>03022022</td>
                                <td>02/2022</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="printPopup" class="modal" [style.display]="printPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">Email</span>
            <h6 class="close text-right" (click)="printPopup=!printPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <label class="fs-16 text46 regular">Share with</label><br>
            <div>
                <input type="text" class="form-control forminput col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com">
            </div>
            <div class="clear20"></div>
            <div>
                <input type="text" class="form-control forminput col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com">
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-14 bold okbtngreen" (click)="printPopup=!printPopup">Send</button>
            </div>
        </div>
    </div>
  </div>